import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var AttendeeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M8.845 11.992c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0-8c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm12 3c0-2.33-1.54-4.37-3.74-4.97a1.01 1.01 0 00-1.23.71c-.15.54.17 1.08.71 1.23 1.33.36 2.26 1.6 2.26 3.03 0 1.43-.93 2.69-2.25 3.03a1.002 1.002 0 00.51 1.94c2.21-.58 3.75-2.62 3.75-4.97h-.01zm-7.78 7.05c-.09-.02-.18-.03-.27-.03-.09 0-.18-.03-.27-.03h-7.06a4.34 4.34 0 00-4.31 4.33v1.7c0 1.1.9 2 2 2h11.69c1.1 0 2-.91 2-2.01v-1.7c0-2.2-1.65-3.99-3.78-4.26zm-3.22 5.97h-1v-1.01h1v1.01zm.88-3.01h-2.76l-.5-1.01h3.77l-.5 1.01h-.01zm-7.57 3.02v-1.7c0-1.2.92-2.18 2.08-2.3l1.61 3.22v.78h-3.69zm8.69 0v-.78l1.54-3.08c.85.34 1.46 1.17 1.46 2.15v1.7h-3v.01zm6.68-6.03c-.55 0-1 .45-1 1s.45 1 1 1c1.26 0 2.32 1.54 2.32 2.5v2.52c0 .55.45 1 1 1s1-.45 1-1v-2.52c0-2.04-1.93-4.5-4.32-4.5z"
                    })
                })
            })
        ]
    });
};
AttendeeIcon.isCarinaIcon = true;
export default AttendeeIcon;
